export default function infographic() {
  const widgetName = 'infographic';
  const widgetOpts = infographicOpts;
  const wrapContainerClass = 'infographic-container';

  const infographicHeader = `
    <div class="infographic-header">
      <h2 class="infographic-title">Nation’s Largest</h2>
      <p class="infographic-subtitle">Renaissance Festival Since 1974</p>
    </div>
  `;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
    maxItemsVisible: 5,
    itemsPerPanel: 5,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    slideshow: false,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createSpinnintNumbers(data);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });
  function createSpinnintNumbers(data) {
    let countTo;

    $(infographicHeader).prependTo(`#${widgetName}`);
    $('<div class="sp-container animated"></div>').prependTo(`#${widgetName}`);
    $(`<div class="sp-wrapper"></div>`).appendTo('.sp-container');

    const items = data.items;

    let counter = 0;
    items.forEach(function (item) {
      let dividerElement = counter > 0 ? "<span class='divider'></span>" : '';
      const stat = `
      <div class="sp-block">
        <span class="spinning-text">${item.Description}</span>
        <span class="sp-value">${item.Title}</span>
        ${dividerElement}
      </div>`;
      $('.sp-wrapper').append(stat);
      counter++;
    });

    function formatNumber(num) {
      return num.toLocaleString();
    }

    function animateNumbers(el) {
      countTo = el.attr('data-countNum');
      $({ countNum: el.text() }).animate(
        {
          countNum: countTo,
        },
        {
          duration: 3000,
          easing: 'swing',
          step: function () {
            if (el.hasClass('decimal')) {
              el.text(formatNumber(Math.floor(this.countNum)));
            } else {
              el.text(Math.floor(this.countNum));
            }
          },
          complete: function () {
            if (el.hasClass('decimal')) {
              el.text(formatNumber(this.countNum));
            } else {
              el.text(this.countNum);
            }
          },
        },
      );
    }

    $(`#${widgetName} .sp-block`).each(function () {
      let title = $(this).find('.sp-value');
      let titleNumber = title.find('span');
      let titleNumberNum = title.find('span').text();
      titleNumber.text('0');
      titleNumber.addClass('js-countNum');
      titleNumber.attr('data-countNum', titleNumberNum);
    });

    let cw3 = $(`#${widgetName} .js-countNum`);
    let cw3top = cw3.offset().top;
    let animated = false;
    let vpBtm = $(globalThis).scrollTop() + $(globalThis).height();

    function triggerAnimation(p) {
      if (cw3top < p && !animated) {
        cw3.each(function () {
          animateNumbers($(this));
        });
        animated = true;
      }
    }

    triggerAnimation(vpBtm);

    $(globalThis).scroll(function () {
      let vpBtm = $(globalThis).scrollTop() + $(globalThis).height();
      triggerAnimation(vpBtm);
    });

    $(`#${widgetName} .card-widget-item`).remove();
    $(`#${widgetName}`)
      .wrap(`<div class="${wrapContainerClass}"></div>`)
      .wrap('<div class="inner-container"></div>');
  }
}
